module.exports = __webpack_public_path__ + "img/2-01-07-muscle-rd.20501994.svg";